'use client'

import {useEffect} from "react";
import {event} from "@/gtag";

const GTagEvent = ({action, parameters}) => {

    useEffect(() => {
        event(action, parameters)
    }, [])

    return ''
}

export default GTagEvent